import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import {
    Row,
    Col,
    Input,
    Label,
    Button,
    Card,
    CardBody,
    Form,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Container } from "reactstrap"
import httprequester from '../../lib/httprequester'
import { Typeahead } from 'react-bootstrap-typeahead';

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Editor } from '@tinymce/tinymce-react';
import moment from "moment";
import { GetIndexFromSchema } from '../../helpers/CommonHelper';

class EditTindakanMedis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basic: false,
            listTindakanMedis: [],
            listCategory: [],
            listSpesialis: [],
            listMolekul: [],
            listPenyakit: [],
            listPenulis: [],
            tindakanID: '',
            tindakanJudul: '',
            tindakanPenulis: '',
            tindakanPenyakit: '',
            tindakanMolekul: '',
            tindakanSpesialis: '',
            tindakanKonten: '',
            tindakanGambar: '',
            tindakanVideo: '',
            tindakanCreatedby: '',
            chspepe: false,
            chspe: false,
            chspem: false,
            chspep: false,
            prosess: false,
            name: '',
            status: '',
            tanggalAwal: '',
            tanggalAkhir: '',
            tindakanProductName1: '',
            tindakanProductUrl1: '',
            tindakanProductName2: '',
            tindakanProductUrl2: '',
        };
    }

    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('user'))
        if (x) {
            this.setState({
                name: x.admin_name
            })
        }
        let router = window.location.href;
        let routerSplitter = router.split("/");
        let id = routerSplitter[5];
        let final = id.replace(/\%20/g, ' ');

        // console.log("tindakanID => ", routerSplitter)

        this.setState({
            tindakanID: final,
            status: routerSplitter[6]
        });

        this.getDetailTindakanMedis(final);
        this.getCategory();
        this.getLOV();
    }

    static propTypes = {
        history: PropTypes.object.isRequired
    }

    back = () => {
        this.props.history.push(`/tindakanmedis`)
    }

    getCategory = () => {
        httprequester.get('category/getall', {
            success: async function (response) {

                console.log("resCat => ", response)
                if (response.data.message == "success") {
                    this.setState({
                        listCategory: response.data.detailMessage
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getLOV = () => {
        httprequester.get('artikel/lov', {
            success: async function (response) {

                console.log("resLOV => ", response)
                if (response.data.message == "success") {
                    let datapenyakit = []
                    response.data.detailPenyakit.forEach((v, key) => {
                        // console.log('v',v);
                        datapenyakit.push({
                            penyakit_id: v.penyakit_id,
                            penyakit_name: v.penyakit_name == null ? '-' : v.penyakit_name
                        })
                    })
                    this.setState({
                        listSpesialis: response.data.detailSpecialist,
                        listMolekul: response.data.detailMolekul,
                        listPenyakit: datapenyakit,
                        listPenulis: response.data.detailPenulis
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    getDetailTindakanMedis = (value) => {
        console.log("idnnya => ", this.state.tindakanID)
        let body = {
            "tindakan_id": value
        }

        console.log("body =>", body)
        httprequester.postarticle('tindakan/detail', body, {
            success: async function (response) {
                let data = []
                let cek = response.data.settings.datarows
                console.log("res => ", cek)
                if (response.data.message == "success") {
                    cek.forEach(async (v, key) => {
                        await data.push({
                            tindakan_penulis: v[GetIndexFromSchema('tindakan_penulis', response.data.settings.schema)],
                            tindakan_id: v[GetIndexFromSchema('tindakan_id', response.data.settings.schema)],
                            tindakan_spesialis: v[GetIndexFromSchema('tindakan_spesialis', response.data.settings.schema)],
                            tindakan_content: v[GetIndexFromSchema('tindakan_content', response.data.settings.schema)],
                            created_at: v[GetIndexFromSchema('created_at', response.data.settings.schema)],
                            created_by: v[GetIndexFromSchema('created_by', response.data.settings.schema)],
                            tindakan_penyakit: v[GetIndexFromSchema('tindakan_penyakit', response.data.settings.schema)],
                            tindakan_status: v[GetIndexFromSchema('tindakan_status', response.data.settings.schema)],
                            tindakan_thumbnail: v[GetIndexFromSchema('tindakan_thumbnail', response.data.settings.schema)],
                            tindakan_slug: v[GetIndexFromSchema('tindakan_slug', response.data.settings.schema)],
                            tindakan_molekul: v[GetIndexFromSchema('tindakan_molekul', response.data.settings.schema)],
                            tindakan_video: v[GetIndexFromSchema('tindakan_video', response.data.settings.schema)],
                            tindakan_title: v[GetIndexFromSchema('tindakan_title', response.data.settings.schema)],
                        });

                        const dataTanggalAwal = v[GetIndexFromSchema('tindakan_periode_awal', response.data.settings.schema)];
                        const dataTanggalAkhir = v[GetIndexFromSchema('tindakan_periode_akhir', response.data.settings.schema)];
                        this.setState({
                            tindakanID: v[GetIndexFromSchema('tindakan_id', response.data.settings.schema)],
                            tindakanJudul: v[GetIndexFromSchema('tindakan_title', response.data.settings.schema)],
                            tindakanPenulis: v[GetIndexFromSchema('tindakan_penulis', response.data.settings.schema)],
                            tindakanPenyakit: v[GetIndexFromSchema('tindakan_penyakit', response.data.settings.schema)],
                            tindakanMolekul: v[GetIndexFromSchema('tindakan_molekul', response.data.settings.schema)],
                            tindakanSpesialis: v[GetIndexFromSchema('tindakan_spesialis', response.data.settings.schema)],
                            tindakanKonten: v[GetIndexFromSchema('tindakan_content', response.data.settings.schema)],
                            tindakanGambar: v[GetIndexFromSchema('tindakan_thumbnail', response.data.settings.schema)],
                            tindakanVideo: v[GetIndexFromSchema('tindakan_video', response.data.settings.schema)],
                            tindakanCreatedby: v[GetIndexFromSchema('created_by', response.data.settings.schema)],
                            tanggalAwal: dataTanggalAwal == null || moment(dataTanggalAwal).format('YYYY-MM-DD') == '2022-01-01' ? '' : moment(dataTanggalAwal).format('YYYY-MM-DD'),
                            tanggalAkhir: dataTanggalAkhir == null || moment(dataTanggalAkhir).format('YYYY-MM-DD') == '4712-12-31' ? '' : moment(dataTanggalAkhir).format('YYYY-MM-DD'),
                            tindakanProductName1: v[GetIndexFromSchema('tindakan_product_name_1', response.data.settings.schema)],
                            tindakanProductUrl1: v[GetIndexFromSchema('tindakan_product_url_1', response.data.settings.schema)],
                            tindakanProductName2: v[GetIndexFromSchema('tindakan_product_name_2', response.data.settings.schema)],
                            tindakanProductUrl2: v[GetIndexFromSchema('tindakan_product_url_2', response.data.settings.schema)],
                        });
                    })
                    this.setState({
                        listTindakanMedis: data,
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    saveTindakanMedis = () => {
        let slugLower = this.state.tindakanJudul.toLowerCase();
        let slugRep = slugLower.replace(/\s/g, '-');

        let body = {
            "tindakan_id": this.state.tindakanID,
            "tindakan_penyakit": this.state.tindakanPenyakit.toString(),
            "tindakan_penyakit_search": this.state.tindakanPenyakit.toString(),
            "tindakan_molekul": this.state.tindakanMolekul.toString(),
            "tindakan_molekul_search": this.state.tindakanMolekul.toString(),
            "tindakan_spesialis": this.state.tindakanSpesialis.toString(),
            "tindakan_spesialis_search": this.state.tindakanSpesialis.toString(),
            "tindakan_title": this.state.tindakanJudul,
            "tindakan_title_search": this.state.tindakanJudul,
            "tindakan_penulis": this.state.tindakanPenulis.toString(),
            "tindakan_penulis_search": this.state.tindakanPenulis.toString(),
            // "tindakan_slug": slugRep,
            "tindakan_content": this.state.tindakanKonten,
            "tindakan_thumbnail": this.state.tindakanGambar,
            "tindakan_video": this.state.tindakanVideo,
            "tindakan_status": this.state.status,
            "created_by": this.state.name,
            "tindakan_periode_awal" : this.state.tanggalAwal === "" ? '2022-01-01' : moment(this.state.tanggalAwal).format('YYYY-MM-DD'),
            "tindakan_periode_akhir" : this.state.tanggalAkhir === "" ? '4712-12-31' : moment(this.state.tanggalAkhir).format('YYYY-MM-DD'),
            "tindakan_product_name_1": this.state.tindakanProductName1,
            "tindakan_product_url_1": this.state.tindakanProductUrl1,
            "tindakan_product_name_2": this.state.tindakanProductName2,
            "tindakan_product_url_2": this.state.tindakanProductUrl2,
        }

        console.log("body =>", body)
        this.setState({
            prosess: true
        })
        httprequester.postarticle('tindakan/update', body, {
            success: async function (response) {
                console.log("res => ", response)
                if (response.data.message == "success") {
                    this.setState({
                        basic: true,
                        prosess: false
                    })
                }
            }.bind(this),
            error: function (err) {
                console.log("error", err)
            }.bind(this)

        })
    }

    handleChangeJudul(e) {
        // let data = []
        // data.push({
        //     tindakanJudul: e[0].tindakanJudul
        // })

        this.setState({
            listTindakanMedis: { tindakanJudul: e[0].tindakanJudul }
            // tindakanMolekul: listTindakanMedis.tindakanJudul
        })
        console.log("INIT M", e);
    }

    handleChangePenulis(e) {
        this.setState({
            tindakanPenulis: e
        })
        console.log("INIT N", e);
    }

    handleChangeSpesialis(e) {
        this.setState({
            tindakanSpesialis: e
        })
        console.log("INIT S", e);
    }

    handleChangeMolekul(e) {
        this.setState({
            tindakanMolekul: e
        })
        console.log("INIT M", e);
    }

    handleChangePenyakit(e) {
        this.setState({
            tindakanPenyakit: e
        })
        console.log("INIT P", e);
    }

    handleEditorChange = (e) => {
        console.log(
            'Content was updated:',
            e.target.getContent()
        );
        this.setState({
            tindakanKonten: e.target.getContent()
        })
    }

    render() {
        const option = this.state.listSpesialis.map(o => o.specialist_name)
        const optionMolekul = this.state.listMolekul.map(o => o.molekul_name)
        const optionPenyakit = this.state.listPenyakit.map(o => o.penyakit_name)
        const optionPenulis = this.state.listPenulis.map(o => o.penulis_name)
        // console.log("judul => ", this.state.listTindakanMedis[0])
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Edit Tindakan Medis Spesialistik</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Tindakan Medis Spesialistik" breadcrumbItem="Edit Tindakan Medis Spesialistik" />

                        {this.state.basic ? (
                            <SweetAlert
                                title="Tindakan Medis Spesialistik berhasil di simpan"
                                onConfirm={() => this.back()}
                            ></SweetAlert>
                        ) : null}

                        {this.state.prosess ? (
                            <SweetAlert title="proses simpan ..." showConfirm={false} >
                            </SweetAlert>
                        ) : null}

                        {this.state.listTindakanMedis.map(function (tindakan, index) {
                            return <Col key={index}>
                                <Row>
                                    <Col lg={12}>
                                        <Card>
                                            <CardBody>
                                                <Form>

                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-firstname-Input">Judul Tindakan Medis Spesialistik</Label>
                                                        <Input
                                                            id="tindakanJudul"
                                                            type="input"
                                                            placeholder={tindakan.tindakan_title}
                                                            // onChange={(e) => this.handleChangeJudul(e)}
                                                            onChange={(e) => this.setState({ tindakanJudul: e.target.value })}
                                                            value={this.state.tindakanJudul}
                                                        />
                                                    </div>

                                                    <Row>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Penulis
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspepe: !this.state.chspepe })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-firstname-Input">Penulis</Label> */}
                                                                {(!this.state.chspepe) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.tindakanPenulis} />
                                                                    : <Typeahead
                                                                        // allowNew
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Penulis"
                                                                        labelKey="name"
                                                                        options={optionPenulis}
                                                                        onChange={(e) => this.handleChangePenulis(e)}
                                                                        value={this.state.tindakanPenulis}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <Label htmlFor="formrow-email-Input">URL Gambar Thumbnail</Label>
                                                                <Input
                                                                    id="animasiThumbnail"
                                                                    type="input"
                                                                    placeholder={tindakan.tindakan_thumbnail}
                                                                    onChange={(e) => this.setState({ tindakanGambar: e.target.value })}
                                                                    value={this.state.tindakanGambar}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={4}>
                                                            <div className="mb-3">
                                                                <Label htmlFor="formrow-email-Input">URL Video</Label>
                                                                <Input
                                                                    id="tindakanVideo"
                                                                    type="input"
                                                                    placeholder={tindakan.tindakan_video}
                                                                    onChange={(e) => this.setState({ tindakanVideo: e.target.value })}
                                                                    value={this.state.tindakanVideo}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Spesialisasi
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspe: !this.state.chspe })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputCity">Spesialis</Label> */}
                                                                {(!this.state.chspe) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.tindakanSpesialis} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Spesialis"
                                                                        labelKey="name"
                                                                        options={option}
                                                                        onChange={(e) => this.handleChangeSpesialis(e)}
                                                                        value={this.state.tindakanSpesialis}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Molekul
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspem: !this.state.chspem })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputState">Molekul</Label> */}
                                                                {(!this.state.chspem) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.tindakanMolekul} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Molekul"
                                                                        labelKey="name"
                                                                        options={optionMolekul}
                                                                        onChange={(e) => this.handleChangeMolekul(e)}
                                                                        value={this.state.tindakanMolekul}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>

                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Label for="exampleSpesialisasi">
                                                                        Penyakit
                                                                    </Label>
                                                                    <a className="font-ri-color" style={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => this.setState({ chspep: !this.state.chspep })} >ubah</a>
                                                                </div>
                                                                {/* <Label htmlFor="formrow-InputZip">Penyakit</Label> */}
                                                                {(!this.state.chspep) ?
                                                                    <Input
                                                                        name="judul"
                                                                        disabled
                                                                        type="text"
                                                                        value={this.state.tindakanPenyakit} required />
                                                                    : <Typeahead
                                                                        id="basic-typeahead-multiple"
                                                                        multiple
                                                                        placeholder="Pilih Penyakit"
                                                                        labelKey="name"
                                                                        options={optionPenyakit}
                                                                        onChange={(e) => this.handleChangePenyakit(e)}
                                                                        value={this.state.tindakanPenyakit}
                                                                    />
                                                                }

                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={6}>
                                                            <div className="mb-3">
                                                                <Label>Tanggal Mulai</Label>
                                                                <Input
                                                                    name="tanggal"
                                                                    label="Tanggal Mulai"
                                                                    type="date"
                                                                    onChange={(e) => this.setState({ tanggalAwal: e.target.value })}
                                                                    value={this.state.tanggalAwal}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <div className="mb-3">
                                                                <Label>Tanggal Akhir</Label>
                                                                <Input
                                                                    name="tanggal"
                                                                    label="Tanggal Akhir"
                                                                    type="date"
                                                                    min={moment(this.state.tanggalAwal).format('YYYY-MM-DD')}
                                                                    onChange={(e) => this.setState({ tanggalAkhir: e.target.value })}
                                                                    value={this.state.tanggalAkhir}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    
                                                    <Row>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <Label>Nama Produk Rekomendasi 1</Label>
                                                                <Input
                                                                    id="webinarProductName1"
                                                                    type="input"
                                                                    onChange={(e) => this.setState({ tindakanProductName1: e.target.value })}
                                                                    value={this.state.tindakanProductName1}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={8}>
                                                            <div className="mb-3">
                                                                <Label>URL Produk Rekomendasi 1</Label>
                                                                <Input
                                                                    id="tindakanProductUrl1"
                                                                    type="input"
                                                                    onChange={(e) => this.setState({ tindakanProductUrl1: e.target.value })}
                                                                    value={this.state.tindakanProductUrl1}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4}>
                                                            <div className="mb-3">
                                                                <Label>Nama Produk Rekomendasi 2</Label>
                                                                <Input
                                                                    id="tindakanProductName2"
                                                                    type="input"
                                                                    onChange={(e) => this.setState({ tindakanProductName2: e.target.value })}
                                                                    value={this.state.tindakanProductName2}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={8}>
                                                            <div className="mb-3">
                                                                <Label>URL Produk Rekomendasi 2</Label>
                                                                <Input
                                                                    id="tindakanProductUrl2"
                                                                    type="input"
                                                                    onChange={(e) => this.setState({ tindakanProductUrl2: e.target.value })}
                                                                    value={this.state.tindakanProductUrl2}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: 10 }}>
                                    <Col xs="12" md="12">
                                        <Card>
                                            <CardBody>
                                                <Form method="post">
                                                    <Editor
                                                        apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                                        initialValue={tindakan.tindakan_content}
                                                        init={{
                                                            height: 500,
                                                            menubar: false,
                                                            plugins: [
                                                                'advlist autolink lists link image charmap print preview anchor',
                                                                'searchreplace visualblocks code fullscreen',
                                                                'insertdatetime media table paste code help wordcount'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | ' +
                                                                'bold italic forecolor backcolor | alignleft aligncenter ' +
                                                                'alignright alignjustify | bullist numlist outdent indent lineheight | ' +
                                                                'removeformat link',
                                                            content_style: 'body { font-family:Poppins,Arial,sans-serif; }',
                                                            line_height_formats: '0.2 0.4 0.6 0.8 1 1.2 1.4 1.6 2',
                                                        }}
                                                        onChange={this.handleEditorChange}
                                                    />
                                                </Form>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        }.bind(this))}
                        <Row style={{ paddingTop: 10 }}>
                            <Col xs="12" md="12">
                                <Card>
                                    <Button type="submit" className="btn btn-primary w-md" onClick={() => this.saveTindakanMedis()}>
                                        Submit Tindakan Medis Spesialistik
                                    </Button>
                                </Card>
                            </Col>
                        </Row>
                        {/* <Row md="10" style={{ paddingTop: 8, justifyContent: "end", alignItems: "end" }}>
                            <Button color="danger" onClick={() => this.saveTindakanMedis()}>
                                Submit Artikel
                            </Button>
                        </Row> */}
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

export default EditTindakanMedis;
